import { addDays, format, startOfWeek, parseISO, getISOWeek } from "date-fns";
import { nl } from "date-fns/locale";

export const toISO = (d) => format(d, "yyyy-MM-dd");
export const mondayOf = (d = new Date()) => startOfWeek(d, { weekStartsOn: 1 });
export const weekDays = (monday) => Array.from({ length: 7 }, (_, i) => addDays(monday, i));
export const fmt = (d, f) => format(typeof d === "string" ? parseISO(d) : d, f, { locale: nl });
export const weekNumber = (d) => getISOWeek(d);
export const timeOf = (iso) => fmt(iso, "HH:mm");
export const hoursNL = (h) => Number(h ?? 0).toFixed(2).replace(".", ",");
export const euro = (n) =>
  new Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR" }).format(n ?? 0);

export const ROLE_LABELS = { owner: "Eigenaar", manager: "Manager", employee: "Medewerker" };
export const BUSINESS_TYPES = {
  restaurant: "Restaurant",
  sushi: "Sushirestaurant",
  snackbar: "Snackbar",
  afhaal: "Afhaal / bezorging",
  cafe: "Café",
  overig: "Overig",
};
export const POSITIONS = ["Keuken", "Sushi-chef", "Bediening", "Bar", "Kassa", "Bezorging", "Afwas"];

export { addDays, parseISO };
